import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  TabsComponent,
  RadiosGroupComponent,
  Spinner,
} from '../../../../Components';
import { GetParams, showError } from '../../../../Helper';
import { GetVendorByIdAPI } from '../../../../Services';
import { VendorsVerticalTabsData } from './Sections/VendorsVerticalTabsData';
import { VendorsTranslationPath } from '../I18n/VendorsLocale';
import { useTranslation } from 'react-i18next';
import VendorContextProvider from '../context/VendorContext';

const parentTranslationPath = VendorsTranslationPath;
const translationPath = '';

export const VendorsProfileManagementView = () => {
  const { t } = useTranslation(parentTranslationPath);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [viewType, setViewType] = useState(1);
  const [vendorData, setVendorData] = useState(null);
  const activeItem = useSelector((state) => state.ActiveItemReducer);
  const [activeContactData, setActiveContactData] = useState();
  const [isHavePermissionToViewDetails, setIsHavePermissionToViewDetails] =
    useState(null);
  const [contactReletedWithVendorId, setContactReletedWithVendor] =
    useState(null);

  const [filterBy, setFilterBy] = useState({
    id: null,
    formType: null,
  });

  const onTabChanged = (e, newTap) => {
    setActiveTab(newTap);
  };
  const onViewTypeChangedHandler = (event, newValue) => {
    setViewType(+newValue);
  };

  const GetVendorContactById = useCallback(async (id) => {
    try {
      setIsLoading(true);
      const res = await GetVendorByIdAPI(id || filterBy?.id);
      setContactReletedWithVendor(+res.contactId);
      if (res && res.vendorJson) {
        const vendorContactJson = res.vendorJson;
        const activeVendor = {
          vendor: {
            id: GetParams('id'),
            ...vendorContactJson,
          },
        };
        setActiveContactData(activeVendor);
        setVendorData(vendorContactJson);
      }
    } catch {
      showError(t('something_went_wrong'));
    } finally {
      setIsLoading(false);
    }
  }, []);

  const reloadData = () => {
    GetVendorContactById(filterBy.id || GetParams('id'));
  };

  useEffect(() => {
    setFilterBy({
      formType: (GetParams('form') && +GetParams('form')) || null,
      id: (GetParams('id') && +GetParams('id')) || null,
    });
  }, []);

  useEffect(() => {
    setFilterBy({
      formType: (GetParams('form') && +GetParams('form')) || null,
      id: (GetParams('id') && +GetParams('id')) || null,
    });
  }, []);

  useEffect(() => {
    const vendorId = +GetParams('id');
    if (vendorId && activeTab === 0) GetVendorContactById(vendorId);
  }, [activeTab]);

  return (
    <div className='vendor-profile-wrapper view-wrapper px-2'>
      <VendorContextProvider>
        <Spinner
          isActive={isLoading}
          isAbsolute
        />
        {activeTab === 0 && (
          <div className='d-flex-v-center'>
            <RadiosGroupComponent
              idRef='viewDataRef'
              data={[
                {
                  key: 1,
                  value: t(`${translationPath}all-data`),
                },
                {
                  key: 2,
                  value: t(`${translationPath}missing-data`),
                },
              ]}
              value={viewType}
              labelValue='view'
              labelInput='value'
              valueInput='key'
              themeClass='theme-line'
              parentTranslationPath={parentTranslationPath}
              onSelectedRadioChanged={onViewTypeChangedHandler}
            />
          </div>
        )}
        {
          <TabsComponent
            data={VendorsVerticalTabsData}
            labelInput='label'
            parentTranslationPath={parentTranslationPath}
            themeClasses='theme-solid'
            currentTab={activeTab}
            onTabChanged={onTabChanged}
            dynamicComponentProps={{
              id: filterBy.id,
              viewType,
              parentTranslationPath,
              setActiveTab,
              activeTab,
              typeOf: '1',
              taskRelatedTo: 'Contact',
              formType: 'contact',
              reloadData: reloadData,
              vendorData,
              contactReletedWithVendorId: contactReletedWithVendorId,
            }}
          />
        }
      </VendorContextProvider>
      {/* {isHavePermissionToViewDetails === false && <PermissionDeniedLayout />} */}
    </div>
  );
};
